/**
 * Generated from BookAnimationLayout.fla
 */
export function BookAnimationLayout(this: IBookAnimationLayout) {
	const main = this.main;
	BookAnimationLayout_main.call(this.main);
	main.x = 1024;
	main.y = 768;
	if (main.onLayout) main.onLayout();
	return this;
}
export function BookAnimationLayout_main(this: IBookAnimationLayout_main) {
	const book = this.book;
	BookAnimationLayout_book.call(this.book);
	book.x = -61.3;
	book.y = -727.1;
	if (book.onLayout) book.onLayout();
	const bookLargeRight = this.bookLargeRight;
	BookAnimationLayout_bookLarge.call(this.bookLargeRight);
	bookLargeRight.x = -721.35;
	bookLargeRight.y = -893;
	if (bookLargeRight.scale) bookLargeRight.scale.x = 1.615;
	if (bookLargeRight.scale) bookLargeRight.scale.y = 1.615;
	if (bookLargeRight.onLayout) bookLargeRight.onLayout();
	const bookLargeLeft = this.bookLargeLeft;
	BookAnimationLayout_bookLarge.call(this.bookLargeLeft);
	bookLargeLeft.x = 599.15;
	bookLargeLeft.y = -893;
	if (bookLargeLeft.scale) bookLargeLeft.scale.x = 1.615;
	if (bookLargeLeft.scale) bookLargeLeft.scale.y = 1.615;
	if (bookLargeLeft.onLayout) bookLargeLeft.onLayout();
	const bookSmall = this.bookSmall;
	BookAnimationLayout_bookSmall.call(this.bookSmall);
	bookSmall.x = -112.9;
	bookSmall.y = -125.55;
	if (bookSmall.scale) bookSmall.scale.x = 0.250;
	if (bookSmall.scale) bookSmall.scale.y = 0.250;
	if (bookSmall.onLayout) bookSmall.onLayout();
	return this;
}
function BookAnimationLayout_book(this: IBookAnimationLayout_book) {
	const bookAnimationFrame = this.bookAnimationFrame;
	if (!bookAnimationFrame[0] && bookAnimationFrame.elementFactory) {
		bookAnimationFrame[0] = bookAnimationFrame.elementFactory(0,undefined);
	}
	if (bookAnimationFrame[0]) {
		BookAnimationLayout_bookAnimationFrame0.call(bookAnimationFrame[0] as IBookAnimationLayout_bookAnimationFrame0);
		bookAnimationFrame[0].x = 0;
		bookAnimationFrame[0].y = 0;
		bookAnimationFrame[0].width = 1046.00;
		bookAnimationFrame[0].height = 1119.00;
		if (bookAnimationFrame[0].onLayout) bookAnimationFrame[0].onLayout();
	}
	if (!bookAnimationFrame[1] && bookAnimationFrame.elementFactory) {
		bookAnimationFrame[1] = bookAnimationFrame.elementFactory(1,undefined);
	}
	if (bookAnimationFrame[1]) {
		BookAnimationLayout_bookAnimationFrame1.call(bookAnimationFrame[1] as IBookAnimationLayout_bookAnimationFrame1);
		bookAnimationFrame[1].x = 1.2;
		bookAnimationFrame[1].y = 0;
		bookAnimationFrame[1].width = 998.00;
		bookAnimationFrame[1].height = 1189.00;
		if (bookAnimationFrame[1].onLayout) bookAnimationFrame[1].onLayout();
	}
	if (!bookAnimationFrame[2] && bookAnimationFrame.elementFactory) {
		bookAnimationFrame[2] = bookAnimationFrame.elementFactory(2,undefined);
	}
	if (bookAnimationFrame[2]) {
		BookAnimationLayout_bookAnimationFrame2.call(bookAnimationFrame[2] as IBookAnimationLayout_bookAnimationFrame2);
		bookAnimationFrame[2].x = 0.6;
		bookAnimationFrame[2].y = 0;
		bookAnimationFrame[2].width = 986.00;
		bookAnimationFrame[2].height = 1351.00;
		if (bookAnimationFrame[2].onLayout) bookAnimationFrame[2].onLayout();
	}
	if (!bookAnimationFrame[3] && bookAnimationFrame.elementFactory) {
		bookAnimationFrame[3] = bookAnimationFrame.elementFactory(3,undefined);
	}
	if (bookAnimationFrame[3]) {
		BookAnimationLayout_bookAnimationFrame3.call(bookAnimationFrame[3] as IBookAnimationLayout_bookAnimationFrame3);
		bookAnimationFrame[3].x = -653.4;
		bookAnimationFrame[3].y = -7.2;
		bookAnimationFrame[3].width = 1640.00;
		bookAnimationFrame[3].height = 1416.00;
		if (bookAnimationFrame[3].onLayout) bookAnimationFrame[3].onLayout();
	}
	if (!bookAnimationFrame[4] && bookAnimationFrame.elementFactory) {
		bookAnimationFrame[4] = bookAnimationFrame.elementFactory(4,undefined);
	}
	if (bookAnimationFrame[4]) {
		BookAnimationLayout_bookAnimationFrame4.call(bookAnimationFrame[4] as IBookAnimationLayout_bookAnimationFrame4);
		bookAnimationFrame[4].x = -768.4;
		bookAnimationFrame[4].y = 0;
		bookAnimationFrame[4].width = 1755.00;
		bookAnimationFrame[4].height = 1265.00;
		if (bookAnimationFrame[4].onLayout) bookAnimationFrame[4].onLayout();
	}
	if (!bookAnimationFrame[5] && bookAnimationFrame.elementFactory) {
		bookAnimationFrame[5] = bookAnimationFrame.elementFactory(5,undefined);
	}
	if (bookAnimationFrame[5]) {
		BookAnimationLayout_bookAnimationFrame5.call(bookAnimationFrame[5] as IBookAnimationLayout_bookAnimationFrame5);
		bookAnimationFrame[5].x = -859.8;
		bookAnimationFrame[5].y = -10.8;
		bookAnimationFrame[5].width = 1847.00;
		bookAnimationFrame[5].height = 1144.00;
		if (bookAnimationFrame[5].onLayout) bookAnimationFrame[5].onLayout();
	}
	const bookCovers = this.bookCovers;
	if (!bookCovers[0] && bookCovers.elementFactory) {
		bookCovers[0] = bookCovers.elementFactory(0,undefined);
	}
	if (bookCovers[0]) {
		BookAnimationLayout_bookCover.call(bookCovers[0] as IBookAnimationLayout_bookCover);
		bookCovers[0].x = 601.5;
		bookCovers[0].y = 597.25;
		bookCovers[0].width = 679.00;
		bookCovers[0].height = 849.00;
		if (bookCovers[0].onLayout) bookCovers[0].onLayout();
	}
	if (!bookCovers[1] && bookCovers.elementFactory) {
		bookCovers[1] = bookCovers.elementFactory(1,undefined);
	}
	if (bookCovers[1]) {
		BookAnimationLayout_bookCover.call(bookCovers[1] as IBookAnimationLayout_bookCover);
		bookCovers[1].x = 567.3;
		bookCovers[1].y = 645.7;
		bookCovers[1].width = 610.98;
		bookCovers[1].height = 849.00;
		if (bookCovers[1].onLayout) bookCovers[1].onLayout();
	}
	if (!bookCovers[2] && bookCovers.elementFactory) {
		bookCovers[2] = bookCovers.elementFactory(2,undefined);
	}
	if (bookCovers[2]) {
		BookAnimationLayout_bookCover.call(bookCovers[2] as IBookAnimationLayout_bookCover);
		bookCovers[2].x = 340.1;
		bookCovers[2].y = 730.25;
		bookCovers[2].width = 401.14;
		bookCovers[2].height = 849.00;
		if (bookCovers[2].onLayout) bookCovers[2].onLayout();
	}
	const storyPicture = this.storyPicture;
	BookAnimationLayout_storyPicture.call(this.storyPicture);
	storyPicture.x = 499.5;
	storyPicture.y = 741;
	storyPicture.width = 683.00;
	storyPicture.height = 447.00;
	if (storyPicture.onLayout) storyPicture.onLayout();
	const storyTitle = this.storyTitle;
	BookAnimationLayout_storyTitle.call(this.storyTitle);
	storyTitle.x = 499.5;
	storyTitle.y = 175;
	storyTitle.width = 651.00;
	storyTitle.height = 100.00;
	if (storyTitle.onLayout) storyTitle.onLayout();
	const theEnd = this.theEnd;
	BookAnimationLayout_theEnd.call(this.theEnd);
	theEnd.x = -357.1;
	theEnd.y = 178.05;
	theEnd.width = 480.00;
	theEnd.height = 117.00;
	if (theEnd.onLayout) theEnd.onLayout();
	const lastScene = this.lastScene;
	BookAnimationLayout_lastScene.call(this.lastScene);
	lastScene.x = -356.9;
	lastScene.y = 607.5;
	if (lastScene.onLayout) lastScene.onLayout();
	const storyPictureLast = this.storyPictureLast;
	BookAnimationLayout_bookCover.call(this.storyPictureLast);
	storyPictureLast.x = 484.25;
	storyPictureLast.y = 524.2;
	storyPictureLast.width = 533.91;
	storyPictureLast.height = 667.58;
	if (storyPictureLast.onLayout) storyPictureLast.onLayout();
	const storyTitleLast = this.storyTitleLast;
	BookAnimationLayout_storyTitle.call(this.storyTitleLast);
	storyTitleLast.x = 499.1;
	storyTitleLast.y = 873.35;
	storyTitleLast.width = 455.69;
	storyTitleLast.height = 70.00;
	if (storyTitleLast.onLayout) storyTitleLast.onLayout();
	const pageMask = this.pageMask;
	pageMask.push(218.50,78.35,220.75,-13.70,1018.20,-13.50,1008.75,1128.75,671.80,1127.50,688.15,751.85,700.90,469.70,702.70,324.05,700.90,205.75,695.45,131.10);
	const buttonSpeaker = this.buttonSpeaker;
	BookAnimationLayout_buttonSpeaker.call(this.buttonSpeaker);
	buttonSpeaker.x = -365.3;
	buttonSpeaker.y = 757.3;
	buttonSpeaker.width = 138.00;
	buttonSpeaker.height = 137.00;
	if (buttonSpeaker.onLayout) buttonSpeaker.onLayout();
	const storyText = this.storyText;
	storyText.x = -733;
	storyText.y = 382.7;
	storyText.textAreaWidth = 738.90;
	storyText.textAreaHeight = 262.85;
	storyText.fontSize = 44;
	if (storyText.onLayout) storyText.onLayout();
	const buttonNext = this.buttonNext;
	BookAnimationLayout_buttonNext.call(this.buttonNext);
	buttonNext.x = 500;
	buttonNext.y = 888.5;
	buttonNext.width = 200.00;
	buttonNext.height = 199.00;
	if (buttonNext.onLayout) buttonNext.onLayout();
	const buttonHome = this.buttonHome;
	BookAnimationLayout_buttonHome.call(this.buttonHome);
	buttonHome.x = -822;
	buttonHome.y = 114.75;
	buttonHome.width = 205.00;
	buttonHome.height = 206.00;
	if (buttonHome.onLayout) buttonHome.onLayout();
	return this;
}
function BookAnimationLayout_bookAnimationFrame0(this: IBookAnimationLayout_bookAnimationFrame0) {
	if (this.setLayoutTexture) this.setLayoutTexture("book-animation-frame-0.png", 0.000, 0.000);
	return this;
}
function BookAnimationLayout_bookAnimationFrame1(this: IBookAnimationLayout_bookAnimationFrame1) {
	if (this.setLayoutTexture) this.setLayoutTexture("book-animation-frame-1.png", 0.000, 0.000);
	return this;
}
function BookAnimationLayout_bookAnimationFrame2(this: IBookAnimationLayout_bookAnimationFrame2) {
	if (this.setLayoutTexture) this.setLayoutTexture("book-animation-frame-2.png", 0.000, 0.000);
	return this;
}
function BookAnimationLayout_bookAnimationFrame3(this: IBookAnimationLayout_bookAnimationFrame3) {
	if (this.setLayoutTexture) this.setLayoutTexture("book-animation-frame-3.png", 0.000, 0.000);
	return this;
}
function BookAnimationLayout_bookAnimationFrame4(this: IBookAnimationLayout_bookAnimationFrame4) {
	if (this.setLayoutTexture) this.setLayoutTexture("book-animation-frame-4.png", 0.000, 0.000);
	return this;
}
function BookAnimationLayout_bookAnimationFrame5(this: IBookAnimationLayout_bookAnimationFrame5) {
	if (this.setLayoutTexture) this.setLayoutTexture("book-animation-frame-5.png", 0.000, 0.000);
	return this;
}
function BookAnimationLayout_storyPicture(this: IBookAnimationLayout_storyPicture) {
	if (this.setLayoutTexture) this.setLayoutTexture("book-story-picture-bronte.png", 0.501, 1.000);
	return this;
}
function BookAnimationLayout_storyTitle(this: IBookAnimationLayout_storyTitle) {
	if (this.setLayoutTexture) this.setLayoutTexture("book-story-title-bronte.png", 0.501, 0.000);
	return this;
}
function BookAnimationLayout_theEnd(this: IBookAnimationLayout_theEnd) {
	if (this.setLayoutTexture) this.setLayoutTexture("the-end.png", 0.500, 0.000);
	return this;
}
function BookAnimationLayout_lastScene(this: IBookAnimationLayout_lastScene) {
	const sceneMask = this.sceneMask;
	BookAnimationLayout_sceneMask.call(this.sceneMask);
	sceneMask.x = -362.3;
	sceneMask.y = -271.5;
	sceneMask.width = 724.65;
	sceneMask.height = 541.50;
	if (sceneMask.onLayout) sceneMask.onLayout();
	const sceneFrame = this.sceneFrame;
	BookAnimationLayout_sceneFrame.call(this.sceneFrame);
	sceneFrame.x = -368.5;
	sceneFrame.y = -277.5;
	sceneFrame.width = 737.00;
	sceneFrame.height = 555.00;
	if (sceneFrame.onLayout) sceneFrame.onLayout();
	return this;
}
function BookAnimationLayout_sceneMask(this: IBookAnimationLayout_sceneMask) {
	return this;
}
function BookAnimationLayout_sceneFrame(this: IBookAnimationLayout_sceneFrame) {
	if (this.setLayoutTexture) this.setLayoutTexture("scene-frame.png", 0.000, 0.000);
	return this;
}
function BookAnimationLayout_bookCover(this: IBookAnimationLayout_bookCover) {
	if (this.setLayoutTexture) this.setLayoutTexture("book-cover-dickens.png", 0.501, 0.501);
	return this;
}
function BookAnimationLayout_pageMask(this: IBookAnimationLayout_pageMask) {
	return this;
}
function BookAnimationLayout_buttonSpeaker(this: IBookAnimationLayout_buttonSpeaker) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-speaker.png", 0.500, 0.500);
	return this;
}
function BookAnimationLayout_buttonNext(this: IBookAnimationLayout_buttonNext) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-continue.png", 0.500, 0.500);
	return this;
}
function BookAnimationLayout_buttonHome(this: IBookAnimationLayout_buttonHome) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-home-round.png", 0.500, 0.500);
	return this;
}
function BookAnimationLayout_bookLarge(this: IBookAnimationLayout_bookLarge) {
	const book = this.book;
	BookAnimationLayout_bookAnimationFrame5.call(this.book);
	book.x = -859.8;
	book.y = -10.8;
	book.width = 1847.00;
	book.height = 1144.00;
	if (book.onLayout) book.onLayout();
	return this;
}
function BookAnimationLayout_bookSmall(this: IBookAnimationLayout_bookSmall) {
	const book = this.book;
	BookAnimationLayout_bookAnimationFrame0.call(this.book);
	book.x = 0;
	book.y = 0;
	book.width = 1046.00;
	book.height = 1118.98;
	if (book.onLayout) book.onLayout();
	return this;
}
interface IBookAnimationLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IBookAnimationLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IBookAnimationLayoutSprite extends IBookAnimationLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IBookAnimationLayoutText extends IBookAnimationLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IBookAnimationLayoutPolygon extends Array<number> {
}
interface IBookAnimationLayout {
	readonly main: IBookAnimationLayout_main;
}
interface IBookAnimationLayout_main extends IBookAnimationLayoutContainer {
	readonly book: IBookAnimationLayout_book;
	readonly bookLargeRight: IBookAnimationLayout_bookLarge;
	readonly bookLargeLeft: IBookAnimationLayout_bookLarge;
	readonly bookSmall: IBookAnimationLayout_bookSmall;
}
interface IBookAnimationLayout_book extends IBookAnimationLayoutContainer {
	readonly bookAnimationFrame: IBookAnimationLayoutArray<IBookAnimationLayout_bookAnimationFrame0|IBookAnimationLayout_bookAnimationFrame1|IBookAnimationLayout_bookAnimationFrame2|IBookAnimationLayout_bookAnimationFrame3|IBookAnimationLayout_bookAnimationFrame4|IBookAnimationLayout_bookAnimationFrame5>;
	readonly bookCovers: IBookAnimationLayoutArray<IBookAnimationLayout_bookCover>;
	readonly storyPicture: IBookAnimationLayout_storyPicture;
	readonly storyTitle: IBookAnimationLayout_storyTitle;
	readonly theEnd: IBookAnimationLayout_theEnd;
	readonly lastScene: IBookAnimationLayout_lastScene;
	readonly storyPictureLast: IBookAnimationLayout_bookCover;
	readonly storyTitleLast: IBookAnimationLayout_storyTitle;
	readonly pageMask: IBookAnimationLayout_pageMask;
	readonly buttonSpeaker: IBookAnimationLayout_buttonSpeaker;
	readonly storyText: IBookAnimationLayoutText;
	readonly buttonNext: IBookAnimationLayout_buttonNext;
	readonly buttonHome: IBookAnimationLayout_buttonHome;
}
interface IBookAnimationLayout_bookAnimationFrame0 extends IBookAnimationLayoutSprite {
}
interface IBookAnimationLayout_bookAnimationFrame1 extends IBookAnimationLayoutSprite {
}
interface IBookAnimationLayout_bookAnimationFrame2 extends IBookAnimationLayoutSprite {
}
interface IBookAnimationLayout_bookAnimationFrame3 extends IBookAnimationLayoutSprite {
}
interface IBookAnimationLayout_bookAnimationFrame4 extends IBookAnimationLayoutSprite {
}
interface IBookAnimationLayout_bookAnimationFrame5 extends IBookAnimationLayoutSprite {
}
interface IBookAnimationLayout_storyPicture extends IBookAnimationLayoutSprite {
}
interface IBookAnimationLayout_storyTitle extends IBookAnimationLayoutSprite {
}
interface IBookAnimationLayout_theEnd extends IBookAnimationLayoutSprite {
}
interface IBookAnimationLayout_lastScene extends IBookAnimationLayoutContainer {
	readonly sceneMask: IBookAnimationLayout_sceneMask;
	readonly sceneFrame: IBookAnimationLayout_sceneFrame;
}
interface IBookAnimationLayout_sceneMask extends IBookAnimationLayoutContainer {
}
interface IBookAnimationLayout_sceneFrame extends IBookAnimationLayoutSprite {
}
interface IBookAnimationLayout_bookCover extends IBookAnimationLayoutSprite {
}
interface IBookAnimationLayout_pageMask extends IBookAnimationLayoutPolygon {
}
interface IBookAnimationLayout_buttonSpeaker extends IBookAnimationLayoutSprite {
}
interface IBookAnimationLayout_buttonNext extends IBookAnimationLayoutSprite {
}
interface IBookAnimationLayout_buttonHome extends IBookAnimationLayoutSprite {
}
interface IBookAnimationLayout_bookLarge extends IBookAnimationLayoutContainer {
	readonly book: IBookAnimationLayout_bookAnimationFrame5;
}
interface IBookAnimationLayout_bookSmall extends IBookAnimationLayoutContainer {
	readonly book: IBookAnimationLayout_bookAnimationFrame0;
}
